import * as yup from 'yup';
import { requiredPhoneSchema } from '@billda/shared-ui';

export interface ProfileCaptureFormData {
  givenName: string;
  familyName: string;
  primaryPhoneNumber: string;
}

export const profileCaptureSchema = yup.object().shape({
  givenName: yup
    .string()
    .required('First name is required')
    .max(100, 'First name must be less than 100 characters')
    .trim(),
  familyName: yup
    .string()
    .required('Last name is required')
    .max(100, 'Last name must be less than 100 characters')
    .trim(),
  primaryPhoneNumber: requiredPhoneSchema,
});
